import {onAngular, currentUser, mainAPI} from 'root/angular-injector-provider';
import {generateId} from 'utils/id';
import {refreshBidsIfInView} from 'rfp/bid-manager/main/stores/bids-raw';

let
  bChannel = null,
  bChannelId = null;

(async function initialize(){
  await onAngular();
  currentUser().watch(initializeChannel);
})()

function initializeChannel(u){
  if(bChannel) {
    bChannel.close();
    bChannel = null;
    bChannelId = null;
  }

  if(!u) return;
  bChannelId = generateId();
  bChannel = new BroadcastChannel(`bid-manager-${u.currentUserAccount.id}`);

  bChannel.onmessage = e => {
    refreshBidsIfInView(e.data.bidsIds, e.data.bids);
  }
}

export async function updateBids(bidsIds){
  if(!bChannel) return;
  const ar = await mainAPI().updateBidManagerBids(bidsIds);
  bChannel.postMessage({ channelId: bChannelId, bidsIds, bids: {data: ar.children}});
}
